import { Button, InfoBox, Modal } from 'src/components';

const RemoveCardConfirmation: React.FC<{
  open: boolean;
  pending: boolean;
  hasError: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({
  open,
  pending,
  hasError,
  onCancel,
  onConfirm,
}) => (
  <Modal open={open}>
    <Modal.Title>Usuń zapisaną kartę</Modal.Title>
    <Modal.Content>
      <p>
        Czy na pewno chcesz usunąć zapisaną kartę?
      </p>
      <p>
        Kolejne płatności mogą wymagać podania nowej metody płatności.
      </p>
      {hasError && (
        <InfoBox
          mode="error"
          message="Nie udało się usunąć karty. Spróbuj ponownie."
        />
      )}
    </Modal.Content>
    <Modal.Actions>
      <Button
        label="Anuluj"
        onClick={onCancel}
        disabled={pending}
        variant="minimal"
        color="primary"
      />
      <Button
        label="Usuń kartę"
        onClick={onConfirm}
        disabled={pending}
        pending={pending}
      />
    </Modal.Actions>
  </Modal>
);

export default RemoveCardConfirmation;
